import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import PageHeader from "../components/PageHeader";
import BackToTop from "../components/BackToTop";
import '../css/team.css';

// Import team images
import member1 from "../assets/team/chariman.jpeg";
import member2 from "../assets/team/mina.jpeg";
import member3 from "../assets/team/devan.png";
import member4 from "../assets/team/punam.jpeg";
import member5 from "../assets/team/saju.jpeg";
import dividerImg from "../assets/bg/about_bg.png"
import Client from "../components/Client";

export default function Team() {

    const teamMembers = [
        {
            name: "मीनू चौबे",
            post: "अध्यक्ष",
            image: member1
        },
        {
            name: "मीना अवई",
            post: "उपाध्यक्ष",
            image: member2
        },
        {
            name: "देवंती",
            post: "सदस्य",
            image: member3
        },
        {
            name: "संजू खरवार",
            post: "सदस्य",
            image: member5
        },
        {
            name: "पूनम शर्मा",
            post: "सदस्य",
            image: member4
        }
    ];

    return (
        <>
            <Navbar />
            <PageHeader 
                title="Our Team" 
                path="/team" 
                name="Our Team" 
            />

           <div className="explorebg2">
    <img 
    src={dividerImg}
    alt="Background"
    title="background"
/>
</div>


        <div className="team-heading text-center">
    <h2 className="hindi-title">हमारे पदाधिकारी</h2>
    <div className="heading-line"></div>
    <p className="team-subtitle">
        Meet our dedicated team members working towards community empowerment.
    </p>
</div>

            <div className="team-section py-5">
                <div className="container">
                    <div className="row">

                        {teamMembers.map((member, index) => (
                            <div className="col-md-6 col-lg-3 mb-4" key={index}>
                                <div className="team-card text-center">
                                    <img 
                                        src={member.image} 
                                        alt={member.name} 
                                        className="img-fluid team-img"
                                    />
                                    <div className="team-info">
                                        <h5>{member.name}</h5>
                                        <p>{member.post}</p>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
            <Client/>
            <Footer />
            <BackToTop />
        </>
    );
}